import api from '../../lib/api';
import { 
  url_api_v1_folder_document_shares_post,
  url_api_v1_folder_document_shares_get_otp,
  url_api_v1_folder_document_shares_validate_otp 
} from '../../lib/apiUrl';

export interface FolderDocumentShareRecipient {
  recipient_email?: string;
  user_id?: number | string;
}

class FolderDocumentShareService {
  shareItem = async (projectUuid: string, data: {
    project_folder_id?: number | string;
    document_id?: number | string;
    recipients: FolderDocumentShareRecipient[];
  }) => {
    try {
      const url = url_api_v1_folder_document_shares_post.replace(':project_uuid', projectUuid);
      const response = await api.post(url, data);
      return response.data;
    } catch (error: any) {
      console.error("FolderDocumentShareService.shareItem error:", error);
      throw error;
    }
  };

  getOtp = async (projectUuid: string, key: string) => {
    try {
      const url = url_api_v1_folder_document_shares_get_otp.replace(':project_uuid', projectUuid);
      const response = await api.post(url, { key });
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching OTP.');
      }
      
      return response.data;
    } catch (error) {
      console.error("FolderDocumentShareService.getOtp error:", error);
      throw error;
    }
  };

  validateOtp = async (projectUuid: string, key: string, otp: string) => {
    try {
      const url = url_api_v1_folder_document_shares_validate_otp.replace(':project_uuid', projectUuid);
      const response = await api.post(url, { key, otp });
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while validating OTP.');
      }
      
      return response.data;
    } catch (error) {
      console.error("FolderDocumentShareService.validateOtp error:", error);
      throw error;
    }
  };

  getFolderContents = async (projectUuid: string, key: string, folderUuid?: string) => {
    try {
      const url = `/api/v1/projects/${projectUuid}/folder_document_shares/folder_contents`;
      const response = await api.post(url, { key, folder_uuid: folderUuid });
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching folder contents.');
      }
      
      return response.data;
    } catch (error) {
      console.error("FolderDocumentShareService.getFolderContents error:", error);
      throw error;
    }
  };

  fetchAvailableUsers = async (keyword: string = '', projectId?: string) => {
    try {
      let url = `/users/share_index?keyword=${encodeURIComponent(keyword)}`;
      if (projectId) {
        url += `&project_id=${encodeURIComponent(projectId)}`;
      }
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        },
      });
      return response.json();
    } catch (error) {
      console.error("FolderDocumentShareService.fetchAvailableUsers error:", error);
      throw error;
    }
  };

  fetchExistingShares = async (projectId: string, params: { project_folder_id?: string | number, document_id?: string | number }) => {
    try {
      const cleanParams: any = {};
      if (params.project_folder_id) cleanParams.project_folder_id = params.project_folder_id;
      if (params.document_id) cleanParams.document_id = params.document_id;
      
      const query = new URLSearchParams(cleanParams).toString();
      const url = `/api/v1/projects/${projectId}/folder_document_shares?${query}`;
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        },
      });
      return response.json();
    } catch (error) {
      console.error("FolderDocumentShareService.fetchExistingShares error:", error);
      throw error;
    }
  };

  revokeShare = async (projectId: string, shareId: number) => {
    try {
      const url = `/api/v1/projects/${projectId}/folder_document_shares/${shareId}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        },
      });
      return response.json();
    } catch (error) {
      console.error("FolderDocumentShareService.revokeShare error:", error);
      throw error;
    }
  };
}

const folderDocumentShareService = new FolderDocumentShareService();
export default folderDocumentShareService;
